import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../../../Services/AppContext';
import { loadDOMComponent } from '../../../../helpers';
import UserRelationButton from './UserRelationButton';
import { store } from '../../../../store/store';
import { Provider } from 'react-redux';

loadDOMComponent({
	selector: 'react-user-relation-button',
	callback: ({ container, context }) => {
		const workplaceId = container.getAttribute('workplaceId');
		const userId = container.getAttribute('userId');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<UserRelationButton workplaceId={workplaceId} userId={userId} />
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
